import { SiteLanguageState } from 'src/react/siteLanguage/state/SiteLanguageState';
import { getLanguage } from 'src/utils/getLanguage';

export const SITE_LANGUAGES_DEFAULT_STATE: SiteLanguageState = {
    language: getLanguage(localStorage.getItem('locale')),
};
